/**
 * Browser identification. PLAN.md §16: user-agent sniffing is used ONLY for
 * display (the capability report and the "we recommend Chrome/Firefox" notice),
 * never to choose behaviour. Behaviour is always feature-detected.
 */

export interface BrowserInfo {
  name: string;
  version: string;
  /** WebKit-based Safari (macOS) */
  isDesktopSafari: boolean;
  /** Any browser on iOS/iPadOS (all use WebKit there) */
  isAppleMobile: boolean;
}

export function parseUserAgent(ua: string, maxTouchPoints = 0): BrowserInfo {
  const m = (re: RegExp): string | undefined => re.exec(ua)?.[1];
  // iPadOS 13+ reports itself as "Macintosh"; touch points give it away.
  const isAppleMobile = /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && maxTouchPoints > 1);

  let name = 'Unknown';
  let version = '';
  let v: string | undefined;
  if ((v = m(/Edg(?:e|A|iOS)?\/([\d.]+)/))) {
    name = 'Edge';
    version = v;
  } else if ((v = m(/(?:Firefox|FxiOS)\/([\d.]+)/))) {
    name = 'Firefox';
    version = v;
  } else if ((v = m(/(?:Chrome|CriOS)\/([\d.]+)/))) {
    name = 'Chrome';
    version = v;
  } else if (/Safari\//.test(ua) && (v = m(/Version\/([\d.]+)/))) {
    name = 'Safari';
    version = v;
  }
  const isDesktopSafari = name === 'Safari' && !isAppleMobile;
  return { name, version, isDesktopSafari, isAppleMobile };
}

export function currentBrowser(): BrowserInfo {
  return parseUserAgent(navigator.userAgent, navigator.maxTouchPoints ?? 0);
}
